#@import _
#@import Booking.Views.Base
#@export Booking.Views.Pickers

class Booking.Views.Pickers extends Booking.Views.Base

  constructor: ->
    Booking.Views.Base.apply this, arguments
    @pickers = []

  add: ({view, model, collection, pickerAttributes}) ->
    # Should create the view and add it to the pickers list
    picker = new view
      model: model
      collection: model.get(collection)
      pickerAttributes: pickerAttributes

    @pickers.push picker

    @listenTo picker, 'picker:selected', @pickerSelected

    @listenTo picker, 'picker:expanded', =>
      @trigger 'pickers:expanded'

    @listenTo picker, 'picker:collapsed', =>
      @trigger 'pickers:collapsed'

    picker

  canRender: ->
    true

  pickerSelected: ({picker, selection}) ->
    picker.hide(true)

    @unselectedPickerPromise().done (nextPicker) =>
      if nextPicker?
        nextPicker.show()
      else
        @trigger 'pickers:collapse'

  render: ->
    return this if @pickers.length is 0

    # Should render each picker and append it only if it should render
    for picker in @pickers
      if picker.canRender()
        @$el.append picker.render().el
        picker.delegateEvents()

    @unselectedPickerPromise().done (picker) =>

      if picker
        picker.show()
      else if @model.getPartialIntent() is true
        # TODO check
        # Only if partial Intent true then expand the lastPicker
        # last picker will be datetime picker depending on multiwindow or not
        _.last(@pickers).show()

    this


  unselectedPickerPromise: ->
    promise = $.Deferred()

    resolveWithPicker = (promise) =>
      picker = @firstNotSelected()
      if picker and not picker.isLoading()
        promise.resolve(picker)
        return true
      else
        return false

    if !resolveWithPicker(promise)
      intervalId = setInterval(
        => clearInterval(intervalId) if resolveWithPicker(promise)
        50
      )

    return promise


# Helpers

  firstNotSelected: ->
    _.find(@pickers, (picker) -> picker.canRender() and !picker.selected())

  nextUnselectedPicker: ->
    # While searching for the nextUnselectedPicker we also want
    # to remove the disabled mark from the ones already selected
    for picker in @pickers
      if picker.selected()
        picker.hideDisable()
      else
        return picker

    return undefined
